import {
  type CandidateTab,
  candidateTabs,
} from '@/modules/candidate-detail/types';

export function isCandidateTab(value: string | null): value is CandidateTab {
  return candidateTabs.includes(value as CandidateTab);
}
